import { IDirective, IScope, IAttributes, IAugmentedJQuery, IDirectiveFactory } from "angular";

/**
 * Sets the inner HTML of a HTML element to a value from a given map. This
 * is useful when the values are provided via localization during pug compile-time,
 * so we can switch between them programmatically.
 */
export class ContentMapValueDirective implements IDirective {
  restrict: "A";

  link(scope: IScope, element: IAugmentedJQuery, attrs: IAttributes): void {
    attrs.$observe("contentMapValue", (value: string) => {
      const contentMap = attrs.contentMap ? JSON.parse(attrs.contentMap) : {};
      const content = contentMap[value];
      element.html(content);
    });
  }

  static factory(): IDirectiveFactory {
    return () => new ContentMapValueDirective();
  }
}
